export default __webpack_public_path__ + "static/media/red_20_melon_normal_x_grimace_tech.d100395f.png";